'use client';
var classes = {"eyeDropperIcon":"m_b077c2bc","colorPreview":"m_c5ccdcab","dropdown":"m_5ece2cd7"};

export { classes as default };
//# sourceMappingURL=ColorInput.module.css.mjs.map
